/// <reference types="jquery"/>
/// <reference types="select2"/>
/// <reference types="datatables.net"/>
"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./UI");
require("./Addons");
require("./PointArrets");
require("./Absences");
require("./Datatable");
require("./Dashboard");
require("./Workflow");
require("./Affaire");
require("./Account");
require("./Messages");
require("./Templates");
require("./GestionImports");
require("./BaseDocumentaire");
require("./Document");
require("./TypeFichier");
require("./Transformateur");
require("./Article");
require("./Requeteur");
require("./SharedComponent");
require("./ConventionServitude");
var js_1 = __importDefault(require("@he/wf.admin/js"));
js_1.default($);
var release_notes_admin_1 = __importDefault(require("@he/release-notes.admin"));
release_notes_admin_1.default($);
require("@he/settings.impexp");
$(function () {
    var $body = $("body");
    //On enlève le focus après le click sur une checkbox ou un radiobutton pour éviter que le outlining ne reste affiché
    $body.on("click", "input:checkbox, input:radio", function () {
        $(this).blur();
    });
    //select2
    $("select.select2").select2();
    //span go-on-url
    $body.on("click", "span.go-on-url[href]", function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        document.location.href = $(this).attr("href");
    });
    $body.on("click", "[data-toggle='collapse-menu']", function (e) {
        var $target = $($(this).data("target"));
        $target.toggleClass("show");
    });
    //toggleRaccourcis
    $("#btn-shortcut-hide > i").click(function () {
        $("#btn-shortcut, #space-btn-shorcut").removeClass("d-none");
        $(".d-toggle-hide").toggleClass("col-2").toggleClass("d-none");
        $(".d-toggle").toggleClass("col-10").toggleClass("col-12");
    });
    $("#btn-shortcut").click(function () {
        $("#btn-shortcut, #space-btn-shorcut").addClass("d-none");
        $(".d-toggle-hide").toggleClass("col-2").toggleClass("d-none");
        if ($(window).width() > 1024) {
            $(".d-toggle").toggleClass("col-10").toggleClass("col-12");
        }
    });
    //En mode tablette, on cache par défaut la colonne de droite
    if ($(window).width() <= 1024) {
        $(".boxRaccourcis #btn-shortcut-hide").trigger("click");
    }
    //Custom input file
    $(document).on("change", ".custom-file-input", function () {
        var $me = $(this),
            files = $me[0]["files"],
            fileNames = $.map(files, function (f) {
            return f.name;
        }).join(", ");
        $me.parent().find('.custom-file-label').addClass("selected").html(fileNames);
    })
    // Auto-hide des collapse ouverts
    .on("click", function (e) {
        if ($(e.target).closest(".admin-info-task").length) {
            return;
        }
        $(".collapse.autohide.show").collapse('hide');
    });
    $.each($(".message-info-edit .datepicker, .message-info-new .datepicker"), function (i, el) {
        var $el = $(el);
        var $icon = $el.prev();
        var eventIcon = function eventIcon(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $el.data("DateTimePicker").toggle();
        };
        $el.datetimepicker({
            viewMode: "days",
            format: "DD/MM/YYYY"
        }).on("dp.hide", function () {
            setTimeout(function () {
                $icon.one("click", eventIcon);
            }, 300);
        }).on("dp.show", function () {
            $icon.off();
        });
        if ($el.parents(".message-info-new").length > 0) {
            $el.data("DateTimePicker").minDate(new Date());
            $el.val("");
        }
        $icon.one("click", eventIcon);
        if ($el.hasClass("debut")) {
            var $fin = $(".message-info-edit .datepicker.fin, .message-info-new .datepicker.fin");
            $el.on("dp.change", function () {
                $fin.data("DateTimePicker").minDate($el.val() ? $el.data("DateTimePicker").date().add(1, "day") : new Date());
            });
        }
    });
    $("div.boxMsg").find("button.close").on("click", function () {
        var $this = $(this);
        var target = $this.data("save-cookie").toString().split(",");
        $.ajax({
            url: "/Affaires/SaveMessagesInfoReadInCookie",
            type: "get",
            data: {
                ids: $this.data("save-cookie")
            }
        }).done(function () {
            var container = $("div.boxMsg");
            $.each(target, function (i, el) {
                container.find("button.close[data-save-cookie=" + el + "]").parents(".row:first").remove();
            });
            if (container.find(">div.row:not(.all)").length === 0) {
                container.remove();
            } else if (container.find(">div.row:not(.all)").length === 1) {
                container.find(">div.row.all").remove();
            }
        });
    });
    //Repli des lignes dans la liste des documents
    $("table.table-document").find("th[colspan]").on("click", function () {
        var $this = $(this);
        $this.parents("table").find("tr[data-wf=" + $this.data("wf") + "]").toggle();
        $this.find("i").toggleClass("fa-rotate-90");
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/site.ts
// module id = 458
// module chunks = 0